<template>
  <AsideContainer>
    <template>
      <ArticleHeadMenu
        v-if="!isMobile"
        :articleID="temple.id"
        :referenceType="3"
      />
      <FieldIdentitiy 
        v-if="!isMobile"
        :identity="temple.identity"
        :space="temple.space"
      />
      <FieldPhone 
        v-if="!isMobile"
        :telephone="temple.telephone"
      />
      <FieldOpeningInfo
        v-if="!isMobile"
        :openingInfo="temple.opening_info"
      />
      <!-- Google map -->
      <FieldGoogleMap
        v-if="temple.address"
        :clickable="true"
        :iframeTitle="temple.name"
        :address="temple.address"
        :position="{ lat: temple.lat, lng: temple.lng }"
        @update:getGeoCodedPosition="
          $store.dispatch('getGeoCodedPosition', $event)
        "
      />
      <!-- 圖鑑集 -->
      <FieldAlbum
        linkPath="album"
        displayType="album"
        :titleImage="{ src: 'more-albums', alt: '圖鑑集', mode: 'medium' }"
        :fieldData="temple.related_albums"
      />
      <!-- 外部連結 -->
      <FieldOtherLinks
        :links="temple.links"
        :titleImage="{
          src: 'title_other_link',
          alt: '外部連結',
          mode: 'medium',
          target: 'blank',
        }"
      />
      <!-- 推薦廟宇 -->
      <FieldRecommend
        linkPath="temple"
        displayType="temple"
        :titleImage="{ src: 'more-temples', alt: '推薦廟宇', mode: 'thick' }"
        :fieldData="temple.related_temples"
      />
    </template>
  </AsideContainer>
</template>
<script>
import AsideContainer from './AsideContainer'
import ArticleHeadMenu from '../article/ArticleHeadMenu'
import FieldIdentitiy from './FieldIdentitiy'
import FieldPhone from './FieldPhone'
import FieldOpeningInfo from './FieldOpeningInfo'
import FieldGoogleMap from './FieldGoogleMap'
import FieldAlbum from './FieldAlbum'
import FieldOtherLinks from './FieldOtherLinks'
import FieldRecommend from './FieldRecommend'

export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AsideContainer,
    ArticleHeadMenu,
    FieldIdentitiy,
    FieldPhone,
    FieldOpeningInfo,
    FieldGoogleMap,
    FieldAlbum,
    FieldOtherLinks,
    FieldRecommend
  },
  computed: {
    temple() {
      return this.$store.getters.temple;
    },
  }
}
</script>

<style>

</style>